<template>
	<div>
		<v-snackbar
			v-model="snackbar"
			:timeout="10000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<v-form v-model="formValid" ref="form">
			<v-container class="content" fluid>
				<v-layout column>
					<v-flex>
						<h1 class="display-1">Arbeitspläne</h1>
					</v-flex>
					<v-flex>
						<table>
							<thead>
								<tr>
									<th style="text-align: left">
										<v-checkbox
											v-model="kombiConfig.show"
											hide-details
											:title="
												kombiConfig.indeterminate
													? 'Klicken um nur Pläne OHNE Kombibearbeitung anzuzeigen'
													: kombiConfig.show
														? 'Klicken um Pläne MIT und OHNE Kombibeareitung anzeigen'
														: 'Klicken um nur Pläne MIT Kombibearbeitung anzeigen'
											"
											@click.stop="stateChanged(kombiConfig)"
											:indeterminate="kombiConfig.indeterminate"
										>
										</v-checkbox>
										Umformungen
									</th>
									<th style="text-align: left; vertical-align: bottom">
										Manuell entgraten
									</th>
									<th style="text-align: left; vertical-align: bottom">
										Trowalisieren
									</th>
									<th style="text-align: left; vertical-align: bottom">Webern</th>
									<th style="text-align: left; vertical-align: bottom">
										Abkanten
									</th>
									<th style="text-align: left">
										<v-checkbox
											v-model="weldingConfig.show"
											hide-details
											:title="
												weldingConfig.indeterminate
													? 'Klicken um nur Pläne OHNE Schweißen anzuzeigen'
													: weldingConfig.show
														? 'Klicken um Pläne MIT und OHNE Schweißen anzeigen'
														: 'Klicken um nur Pläne MIT Schweißen anzeigen'
											"
											@click.stop="stateChanged(weldingConfig)"
											:indeterminate="weldingConfig.indeterminate"
										>
										</v-checkbox>
										Schweißen
									</th>
									<th style="text-align: left">
										<v-checkbox
											v-model="powderCoatingConfig.show"
											hide-details
											:title="
												powderCoatingConfig.indeterminate
													? 'Klicken um nur Pläne OHNE Pulverbeschichten anzuzeigen'
													: powderCoatingConfig.show
														? 'Klicken um Pläne MIT und OHNE Pulverbeschichten anzeigen'
														: 'Klicken um nur Pläne MIT Pulverbeschichten anzeigen'
											"
											@click.stop="stateChanged(powderCoatingConfig)"
											:indeterminate="powderCoatingConfig.indeterminate"
										>
										</v-checkbox>
										Pulverbeschichten
									</th>
									<th style="text-align: left">
										<v-checkbox
											v-model="feuerverzinkenConfig.show"
											hide-details
											:title="
												feuerverzinkenConfig.indeterminate
													? 'Klicken um nur Pläne OHNE Feuerverzinkung anzuzeigen'
													: feuerverzinkenConfig.show
														? 'Klicken um Pläne MIT und OHNE Feuerverzinkung anzeigen'
														: 'Klicken um nur Pläne MIT Feuerverzinkung anzeigen'
											"
											@click.stop="stateChanged(feuerverzinkenConfig)"
											:indeterminate="feuerverzinkenConfig.indeterminate"
										>
										</v-checkbox>
										Feuerverzinken
									</th>
									<th style="text-align: left">
										<v-checkbox
											v-model="galvanischVerzinkenConfig.show"
											hide-details
											:title="
												galvanischVerzinkenConfig.indeterminate
													? 'Klicken um nur Pläne OHNE galvanischer Verzinkung anzuzeigen'
													: galvanischVerzinkenConfig.show
														? 'Klicken um Pläne MIT und OHNE galvanischer Verzinkung anzeigen'
														: 'Klicken um nur Pläne MIT galvanischer Verzinkung anzeigen'
											"
											@click.stop="stateChanged(galvanischVerzinkenConfig)"
											:indeterminate="galvanischVerzinkenConfig.indeterminate"
										>
										</v-checkbox>
										Galvanisch-Verzinken
									</th>
									<th style="vertical-align: bottom">Name</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(plan, index) in fertiger.workplanViewModels"
									:key="index"
									:style="{
										borderTop: '1px solid grey',
										visibility: showWorkplan(plan),
									}"
								>
									<td>
										<v-checkbox v-model="plan.kombi" disabled></v-checkbox>
									</td>
									<td>
										<v-checkbox
											v-model="plan.manuellEntgraten"
											disabled
										></v-checkbox>
									</td>
									<td>
										<v-checkbox
											v-model="plan.trowalisieren"
											disabled
										></v-checkbox>
									</td>
									<td>
										<v-checkbox v-model="plan.webern" disabled></v-checkbox>
									</td>
									<td>
										<v-checkbox v-model="plan.abkanten" disabled></v-checkbox>
									</td>
									<td>
										<v-checkbox v-model="plan.schweissen" disabled></v-checkbox>
									</td>
									<td>
										<v-checkbox
											v-model="plan.pulverbeschichten"
											disabled
										></v-checkbox>
									</td>
									<td>
										<v-checkbox
											v-model="plan.feuerverzinken"
											disabled
										></v-checkbox>
									</td>
									<td>
										<v-checkbox
											v-model="plan.galvanischVerzinken"
											disabled
										></v-checkbox>
									</td>
									<td class="name">
										<v-text-field
											v-model="plan.name"
											:rules="workplanNameRule"
											style="margin-top: 0; padding-top: 0"
											@blur="plan.name = plan.name.trim()"
										></v-text-field>
									</td>
								</tr>
							</tbody>
						</table>
					</v-flex>
					<v-flex>
						<v-btn
							class="blexon-button"
							:disabled="isSaving || isLoading || !formValid"
							@click="saveWorkplans()"
						>
							<v-progress-circular
								size="16"
								v-if="isSaving || isLoading"
								indeterminate
							></v-progress-circular>
							Speichern
						</v-btn>
					</v-flex>
				</v-layout>
			</v-container>
		</v-form>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	data() {
		return {
			laser: true,
			isSaving: false,
			isLoading: false,
			snackbar: false,
			snackbarText: "",
			formValid: false,
			powderCoatingConfig: {
				show: false,
				indeterminate: false,
			},
			weldingConfig: {
				show: false,
				indeterminate: false,
			},
			kombiConfig: {
				show: false,
				indeterminate: false,
			},
			feuerverzinkenConfig: {
				show: false,
				indeterminate: false,
			},
			galvanischVerzinkenConfig: {
				show: false,
				indeterminate: false,
			},
			workplanNameRule: [(v) => v.length <= 50 || "Max. 50 Zeichen"],
		};
	},

	mounted() {
		if (this.fertiger.workplanViewModels.some((p) => p.schweissen === true && p.name !== "")) {
			this.weldingConfig.indeterminate = true;
		}
		if (
			this.fertiger.workplanViewModels.some(
				(p) => p.pulverbeschichten === true && p.name !== ""
			)
		) {
			this.powderCoatingConfig.indeterminate = true;
		}
		if (this.fertiger.workplanViewModels.some((p) => p.kombi === true && p.name !== "")) {
			this.kombiConfig.indeterminate = true;
		}
		if (
			this.fertiger.workplanViewModels.some(
				(p) => p.galvanischVerzinken === true && p.name !== ""
			)
		) {
			this.galvanischVerzinkenConfig.indeterminate = true;
		}
		if (
			this.fertiger.workplanViewModels.some((p) => p.feuerverzinken === true && p.name !== "")
		) {
			this.feuerverzinkenConfig.indeterminate = true;
		}
		this.$refs.form.validate();
	},

	computed: {
		fertiger() {
			var fertigerId = this.$route.params.fertigerId;
			var currentFertiger = this.$store.state.fertiger.filter((f) => f.id == fertigerId);
			return currentFertiger[0];
		},
	},
	methods: {
		showWorkplan(plan) {
			return (plan.pulverbeschichten === this.powderCoatingConfig.show ||
				this.powderCoatingConfig.indeterminate) &&
				(plan.schweissen === this.weldingConfig.show || this.weldingConfig.indeterminate) &&
				(plan.kombi === this.kombiConfig.show || this.kombiConfig.indeterminate) &&
				(plan.galvanischVerzinken === this.galvanischVerzinkenConfig.show ||
					this.galvanischVerzinkenConfig.indeterminate) &&
				(plan.feuerverzinken === this.feuerverzinkenConfig.show ||
					this.feuerverzinkenConfig.indeterminate)
				? "visible"
				: "collapse";
		},

		stateChanged(config) {
			if (config.indeterminate) {
				config.indeterminate = false;
			} else {
				if (config.show === false) {
					config.show = true;
				} else {
					config.show = false;
					config.indeterminate = true;
				}
			}
		},

		async saveWorkplans() {
			if (!this.isSaving && !this.isLoading) {
				await this.savePlans(); // savePLans never throws
				await this.reloadWorkplans();
			}
		},
		async savePlans() {
			try {
				this.isSaving = true;
				await httpClient().post(
					`api/Fertiger/UpdateWorkplans?fertigerId=${this.fertiger.id}`,
					this.fertiger.workplanViewModels
				);
				this.setSnackbarText("Arbeitspläne erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText("Arbeitspläne konnten nicht gespeichert werden.");
			} finally {
				this.isSaving = false;
			}
		},
		async reloadWorkplans() {
			try {
				this.isLoading = true;
				let response = await httpClient().get(
					`api/Fertiger/GetFertigerWorkplans?fertigerId=${this.fertiger.id}`
				);
				console.log("Loaded Fertiger workplans successfully");
				let payload = {
					fertigerId: this.fertiger.id,
					workplans: response.data,
				};
				this.$store.commit("setFertigerWorkplans", payload);
			} catch (err) {
				console.log(err);
			} finally {
				this.isLoading = false;
			}
		},
		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>

<style scoped>
td {
	min-width: 140px;
}
td.name {
	width: 100%;
}
</style>
